import FilterRow from './adapter';

export default FilterRow;
